export function getNameInitials(fullName = '') {
  const splittedFullName = fullName.split(' ').filter(Boolean);
  const letters = splittedFullName.map((name) => name[0]);
  const nameInitials = letters.slice(0, 2).join('');

  return nameInitials.toUpperCase();
}
